/**
 * src/components/footer/FooterApps.js
 *
 * Badges de descarga para App Store y Google Play.
 * Props: { apps: Array<{ store, icon, href, label }> }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { brandIcons } from '@/shared/brandIcons.js'

/* Mapea el nombre de la tienda al icono SVG de marca */
const STORE_ICON = {
    'App Store':   brandIcons.appstore,
    'Google Play': brandIcons.googleplay,
}

define('FooterApps', ({ apps = [] }) => {
    const badges = apps.map(({ store, icon, href, label }) => {
        const svg = STORE_ICON[store]
        return h('a', { className: 'footer-apps__badge', href, target: '_blank', rel: 'noopener' },
            svg
                ? h('span', { className: 'footer-apps__badge-icon', innerHTML: svg })
                : h('span', { className: 'footer-apps__badge-icon' }, icon),
            h('span', { className: 'footer-apps__badge-text' },
                h('small', {}, label),
                h('strong', {}, store)
            )
        )
    })

    return h('div', { className: 'footer-apps' },
        h('p', { className: 'footer-apps__label' }, 'Descarga la app'),
        h('div', { className: 'footer-apps__list' }, ...badges)
    )
})
